export default __webpack_public_path__ + "static/media/logo.bcf86c99.svg";